import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, exhaustMap, map } from 'rxjs/operators';
import { DashboardAdapter } from '../../adapters/dashboard.adapter';
import {
  loadDashboardKpis,
  loadDashboardKpisFailure,
  loadDashboardKpisSuccess,
} from './dashboard-kpis.actions';

@Injectable()
export class DashboardKpisEffects {
  private readonly actions$ = inject(Actions);
  private readonly dashboardAdapter = inject(DashboardAdapter);

  loadDashboardKpis$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadDashboardKpis),
      exhaustMap(({ timeRange }) =>
        this.dashboardAdapter.getKpis(timeRange).pipe(
          map((dashboardKpis) => loadDashboardKpisSuccess({ dashboardKpis })),
          catchError((error) => of(loadDashboardKpisFailure({ error })))
        )
      )
    )
  );
}
